import React from 'react';

import styles from './styles.module.scss'; // eslint-disable-line no-unused-vars

function CustomLayout(props) {
  return (
    <div className={styles.root}>
      <main>
        <div>{props.children}</div>
      </main>
    </div>
  );
}

export default CustomLayout;
